import { useDocumentTitle } from "~src/hooks/useDocumentTitle"
import { Image, Swiper, Tabs, Toast, Mask } from "antd-mobile"
import { Popup } from "antd-mobile/2x"
import React, { useCallback, useMemo, useState } from "react"
import styles from "./index.module.less"
import { useGetWelfareRid } from "~src/hooks/useGetWelfareRid"
import { getResidualIntegral, GetWelfareBanner, GetWelfareCategory, GetWelfareList, postExchange } from "~src/service/welfare"
import WelfareItem from "./WelfareItem"
import { WelfareBannerType, WelfareItemsType, WelfareType } from "~src/service/welfare/welfare"
import MockContent from "../components/MockContent/index"
import classNames from "classnames"
import useQuery from "~src/hooks/useQuery"
import { useNavigate } from "react-router-dom"

const Welfare = () => {
  useDocumentTitle('公益行')
  const searchQuery = useQuery()
  const id = searchQuery("id") || "1"
  const cid = sessionStorage.getItem("cid") || ""
  const [rid, setRid] = useState<string>("")
  const [point, setPoint] = useState<string>("0")
  const [visible, setVisible] = useState<boolean>(false)
  const [welfareSrc, setWelfareSrc] = useState<string>("")
  const [visibleMask, setVisibleMask] = useState<boolean>(false)
  const [activeId, setActiveId] = useState<string>(cid || id || "")
  console.log(activeId)
  const [banner, setBanner] = useState<WelfareBannerType[]>([])
  const [tabList, setTabList] = useState<WelfareType[]>([])
  const [welfareList, setWelfareList] = useState<WelfareItemsType[]>([])
  const [welfare, setWelfare] = useState<WelfareItemsType>({} as WelfareItemsType)
  const navigate = useNavigate()
  const onJumpSwiperItem = (item: WelfareBannerType) => {
    navigate(`/welfare/details/${item.redirect}`)
  }
  const getBannerList = async (rid: string) => {
    const list = await GetWelfareBanner(rid)
    setBanner(list)
  }
  const getCategoryList = async (rid: string) => {
    const list = await GetWelfareCategory(rid)
    setTabList(list)
  }
  const getWelfareList = async (rid: string, categoryId = activeId, pageNum = "1", pageSize = "10") => {
    const { records = [] } = await GetWelfareList(rid, { pageNum, pageSize, categoryId: categoryId })
    setWelfareList(records)
  }

  const onTabsChange = (key: string) => {
    setActiveId(() => key)
    getWelfareList(rid, key)
    sessionStorage.setItem("cid", key)
  }
  const onExchange = useCallback(async (item: WelfareItemsType) => {
    setPoint(await getResidualIntegral(rid))
    setVisible(true)
    setWelfare(item)
  }, [rid])
  const onExchangeWelfare = useCallback(async () => {
    try {
      if (Number(point) < welfare.priceFee) {
        Toast.show(`${welfare.priceUnit}不足`)
        return;
      }
      const data = await postExchange(rid, { skuId: String(welfare.skuId) })
      if (data) {
        setWelfareSrc(data)
        setVisible(false)
        setVisibleMask(true)
      }
    } catch (error) { /* empty */ }
  }, [point, rid, welfare.priceFee, welfare.priceUnit, welfare.skuId])
  useGetWelfareRid(async (rid) => {
    setRid(() => rid)
    getBannerList(rid)
    getCategoryList(rid)
    await setActiveId(cid || id)
    getWelfareList(rid, cid || id)
  }, [])

  const activetitle = useMemo(() => {
    return {
      "--active-title-color": "#23D85A",
      "--active-line-height": "2px",
      "--active-line-color": "#23D85A",
    }
  }, [])
  const items = banner.map((item, index) => (
    <Swiper.Item key={index}>
      <div
        className={styles.content}
        onClick={onJumpSwiperItem.bind(null, item)}
      >
        <Image src={item.imageUrl} alt="" />
      </div>
    </Swiper.Item>
  ))

  const tabsTitle = (item: WelfareType) => {
    return <div className={styles.titem}>
      <img className={styles["titem-icon"]} src={item.icon} alt={item.name} />
      <div className={styles["titem-text"]}>{item.name}</div>
    </div>
  }

  return <div >
    <Swiper className={styles.content} loop autoplay>{items}</Swiper>
    <div className={styles.wel}>
      <Tabs className={styles.tabs} style={activetitle} defaultActiveKey={activeId} onChange={onTabsChange}>
        {
          tabList.map((item) => {
            return <Tabs.Tab title={tabsTitle(item)} key={String(item.id)} />
          })
        }
      </Tabs>
      {
        welfareList?.map((item, index) => {
          return <div className={styles["wel-item"]} key={index}>
            <WelfareItem item={item} onExchange={onExchange} />
          </div>
        })
      }
    </div>
    <Mask visible={visibleMask} onMaskClick={() => setVisibleMask(false)}>
      <div className={styles.mask}>
        <img className={styles["mask-content"]} src={welfareSrc} alt="" />
        <div className={styles["mask-close"]}>
          <span onClick={() => setVisibleMask(false)} className={classNames("iconfont", styles["mask-close-btn"])}>&#xe61c;</span>
        </div>
      </div>
    </Mask>
    <Popup
      visible={visible}
      showCloseButton
      onClose={() => {
        setVisible(false)
      }}
      onMaskClick={() => {
        setVisible(false)
      }}
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        minHeight: '30vh',
      }}>
      <MockContent point={point} item={welfare} onExchange={onExchangeWelfare} />
    </Popup>
  </div>
}
export default Welfare
